import { useCallback } from 'react';
import type { TabsProps } from 'antd';

import NestedResourceSortableTabBar, { NestedResourceSortableTabBarProps } from '.';

type RenderTabBar = NonNullable<TabsProps['renderTabBar']>;

export const useNestedResourceSortableTabBar = ({
    allowReorder,
    droppableId,
    onDragEnd,
    parentLocked,
    resource,
    resourceIds,
}: NestedResourceSortableTabBarProps): RenderTabBar =>
    useCallback(
        (tabBarProps, DefaultTabBar) => (
            <NestedResourceSortableTabBar
                DefaultTabBar={DefaultTabBar}
                allowReorder={allowReorder}
                droppableId={droppableId}
                onDragEnd={onDragEnd}
                parentLocked={parentLocked}
                resource={resource}
                resourceIds={resourceIds}
                tabBarProps={tabBarProps}
            />
        ),
        [allowReorder, droppableId, onDragEnd, parentLocked, resource, resourceIds],
    );
